import React, { useState } from 'react';
import HeaderImage from '../assets/servicecs_header.png';
import ClientImage1 from '../assets/client_services-1.png';
import ClientImage2 from '../assets/client_services-2.png';
import ClientImage3 from '../assets/client_services-3.png';
import ClientImage4 from '../assets/client_services-4.png';
import ClientImage5 from '../assets/client_services-5.png';
import ClientImage6 from '../assets/client_services-6.png';
import ClientImage7 from '../assets/client_services-7.png';
import LawyerImage1 from '../assets/lawyer_services-1.png';
import LawyerImage2 from '../assets/lawyer_services-2.png';
import LawyerImage3 from '../assets/lawyer_services-3.png';
import LawyerImage4 from '../assets/lawyer_services-4.png';
import ImportanceBackground from '../assets/importance-bg.png'
import TestimonialsPerson1 from '../assets/testimonials_person-1.png';
import TestimonialsPerson2 from '../assets/testimonials_person-2.png';
import TestimonialsPerson3 from '../assets/testimonials_person-3.png';
import '../styles/ServiceHeader.css'
import '../styles/ServicesSection.css'
import ServiceCard from '../components/ServiceCard';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player'; //https://www.npmjs.com/package/react-player
import TestimonialsCard from '../components/TestimonialsCard';


const ServicePage = () => {
    const [activeButton, setActiveButton] = useState('clients');
    const clientServicesData = [
        { url: ClientImage1, title: 'Legal Forms/Document Filing Assistance' },
        { url: ClientImage2, title: 'Asylum Application Filing Assistance' },
        { url: ClientImage3, title: 'Asylum Statement & Legal Documents Translation' },
        { url: ClientImage4, title: 'Work Permit & Social Security Number Application Assistance' },
        { url: ClientImage5, title: 'Easy & Attractive Payment Plans For Our Services' },
        { url: ClientImage6, title: 'Indian Passport Application (New/ Renewal) Services' },
        { url: ClientImage7, title: 'Tax Identification Number (Tin) Application Assistance' }
    ];

    const lawyerServiceData = [
        { url: LawyerImage1, title: 'Data Entry Services' },
        { url: LawyerImage2, title: 'Worldwide Client Acquisition & Business Development' },
        { url: LawyerImage3, title: 'Asylum Statement & Legal Documents Translation' },
        { url: LawyerImage4, title: 'Legal Forms/ Document Filing Assistance' }
    ];
    const VideoPath = 'https://www.youtube.com/watch?v=QCw4RiWQA_E';

    const testimonialsData = [
        { url: TestimonialsPerson1, name: 'Sandra Payne', content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', },
        { url: TestimonialsPerson2, name: 'Deo John', content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', },
        { url: TestimonialsPerson3, name: 'Douglas Ray', content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', }
    ];
    return (
        <>
            <header>
                <div className="services_header-image-wrapper">
                    <img src={HeaderImage} alt="" className="services_header-image" />
                    <div className="services_header-image-gradient" />
                    <div className="row">
                        <div className="services_header-content">
                            <h1 className="services_header-title">Our Services</h1>
                            <p className="services_header-para">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                        </div>
                    </div>
                </div>
            </header>
            <main>
                <div className="services_wrapper">
                    <div className="row">
                        <section className="services">
                            <div className="services_section-titles">
                                <h1 className="services_section-title">What We Serve</h1>
                                <p className="services_section-subtitle">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                            </div>
                            <div className="services_button-state-wrapper">
                                <div className="services_button-wrapper">
                                    <button className={`services_button ${activeButton === 'clients' && 'services_button-active'}`} onClick={() => setActiveButton('clients')}>Services For Clients</button>
                                    <button className={`services_button ${activeButton === 'lawyers' && 'services_button-active'}`} onClick={() => setActiveButton('lawyers')}>Services For Lawyers</button>
                                </div>
                                <span
                                    className="services_state-tracker"
                                    style={{
                                        transform: `translateX(${activeButton === 'clients' ? `0%` : '100%'})`,
                                        left: activeButton === ('clients' ? '0' : '25%')
                                    }}
                                />
                            </div>
                            {activeButton === 'clients' ?
                                <div className="services-cards">
                                    {
                                        clientServicesData.map((service, index) => {
                                            return (
                                                <ServiceCard service={service} key={index} />
                                            )
                                        })
                                    }
                                </div> : <div className="services-cards">
                                    {
                                        lawyerServiceData.map((service, index) => {
                                            return (
                                                <ServiceCard service={service} key={index} />
                                            )
                                        })
                                    }
                                </div>
                            }{activeButton === 'clients' ?
                                <div className="services_link-wrapper">
                                    <Link to='/contact' className='services_link'> <span className="responsive_text">CLICK HERE FOR </span>CLIENT SERVICES</Link>
                                </div>
                                :
                                <div className="services_link-wrapper">
                                    <Link to='/lawyer-services' className='services_link'> <span className="responsive_text">CLICK HERE FOR </span>LAWYER SERVICES</Link>
                                </div>
                            }
                        </section>
                    </div>
                    <section className='importance'>
                        <img src={ImportanceBackground} alt="" className="importance_image" />
                        <div className="importance_absolute">
                            <div className="importance_title-wrapper">
                                <h1 className="importance_title">Every Person Who Walks Through Our Door Is Important To Us.</h1>
                            </div>
                            <div className="row">
                                <div className="importance_content">
                                    <h1 className="importance_content-title">Committed to Helping Our Clients Succeed.</h1>
                                    <p className="importance_content-para">Lorem Ipsum is simply dummy text of the printing and
                                        typesetting industry.</p>
                                    <Link to='/contact' className='importance_content-link'>Free Evaluation</Link>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className='testimonials' >
                        <div className="row">
                            <h1 className="testimonials_title">What Our Clients Say</h1>
                            <div className="testimonials_content">
                                <article className="testimonials_video-wrapper">
                                    <ReactPlayer url={VideoPath} controls={true} className='testimonials_video' />
                                    <div className="testimonials_video-content">
                                        <h2 className="testimonials_video-title">A Demo Interview Placeholder</h2>
                                        <p className="testimonials_video-para">Lorem Ipsum is simply dummy text
                                            of the printing and typesetting industry.</p>
                                    </div>
                                </article>
                                <div className="testimonials_cards">
                                    {
                                        testimonialsData.map((testimonial, index) => {
                                            return (
                                                <TestimonialsCard testimonial={testimonial} key={index} />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </section >
                </div>
            </main >
        </>
    );
}

export default ServicePage;
